<template>
  <div>
    <div v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.6); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3 v-if="loading">
            Get Card Request Details...
          </h3>
        </div>
      </div>
    </div>
    <div v-else-if="objData !== null">
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
        <chevron-left-icon size="1.5x" class="custom-class" style="vertical-align: top;"></chevron-left-icon>
        <span class="back">Back</span>
      </div>
      <h1 class=" mt-2 mb-3 font-regular">
        {{ `${objData.account_number}` }} Card
        Request
      </h1>

      <div class="row justify-content-end">
        <router-link v-if="objData.user_id && permissions.includes('view-customer')" :to="{
          name: 'CustomerComponent',
          params: {
            slug: objData.user_id
          }
        }" class="col-auto btn btn-info mr-2">View Customer</router-link>
        <button class="mx-1 col-auto btn btn-success" v-if="
          objData.request_status === 'approved' &&
          objData.provision_status === 'pending'
        " @click="openProModal">
          Provision Card
        </button>
        <button class=" col-auto btn btn-primary" @click="openTreatModal" v-if="objData.request_status === 'pending'">
          Treat Request
        </button>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card mt-2">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6" v-if="objData.provisioned_by !== null">
                  <div class="form-group">
                    <label for="">Provisioned By</label>
                    <div class=" fw-bold text-primary">
                      {{
                        `${objData.provisioned_by.first_name} ${objData.provisioned_by.last_name}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6" v-if="objData.provisioned_by !== null">
                  <div class="form-group">
                    <label for="">Provisioning Status</label>
                    <div class=" fw-bold text-primary">
                      {{
                        `${objData.provision_status}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Request Status</label>
                    <div class=" fw-bold text-primary">
                      {{
                        `${objData.request_status}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Payment Status</label>
                    <div class=" fw-bold text-primary">
                      {{
                        `${objData.payment_status}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery  Status</label>
                    <div class=" fw-bold text-primary">
                      {{
                        `${objData.delivery_status}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Card Type</label>
                    <div class=" fw-bold text-primary">
                      <span class="badge" 
                        :class="{
                          'badge-success': objData.card_category == 'kiddies',
                          'badge-default':  objData.card_category == 'normal'
                        }"
                        >
                          {{ objData.card_category | capitalize }} Card
                      </span>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="col-md-6" v-if="objData.user">
                  <div class="form-group">
                    <label for="">First Name</label>
                    <input type="text" class=" form-control" disabled placeholder="First Name"
                      v-model="objData.user.first_name" />
                  </div>
                </div>
                <div class="col-md-6" v-if="objData.user">
                  <div class="form-group">
                    <label for="">Last Name</label>
                    <input type="text" class=" form-control" disabled placeholder="Last Name"
                      v-model="objData.user.last_name" />
                  </div>
                </div>
                <div class="col-md-6" v-if="objData.user">
                  <div class="form-group">
                    <label for="">Phone Number</label>
                    <input type="text" class=" form-control" disabled placeholder="Last Name"
                      v-model="objData.user.phone_number" />
                  </div>
                </div>
                <div v-if="objData.user">
                  <div class="col-md-12" v-if="objData.user.kyc">
                    <div class="form-group">
                      <label for="">Customer Address</label><br>
                      <strong>
                        {{ objData.user.kyc.address }}<br>
                        {{ objData.user.kyc.city }}<br>
                        {{ objData.user.kyc.state ? objData.user.kyc.state.name : "-" }}
                      </strong>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Account Number</label>
                    <input type="text" class=" form-control" disabled v-model="objData.account_number" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Request Status</label>
                    <input type="text" class=" form-control" disabled placeholder="Request Status"
                      v-model="objData.request_status" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery Method</label>
                    <input type="text" class=" form-control" disabled placeholder="Delivery Method"
                      v-model="objData.delivery_method" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery Status</label>
                    <input type="text" class=" form-control" disabled placeholder="Delivery Status"
                      v-model="objData.delivery_status" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Payment Status</label>
                    <input type="text" class=" form-control" disabled placeholder="Payment Status"
                      v-model="objData.payment_status" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Card Cost</label>
                    <input type="text" class=" form-control" disabled placeholder="Card Cost"
                      v-model="objData.card_cost" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery Cost</label>
                    <input type="text" class=" form-control" disabled placeholder="Delivery Cost"
                      v-model="objData.delivery_cost" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery Cost</label>
                    <input type="text" class=" form-control" disabled placeholder="Delivery Cost"
                      v-model="objData.delivery_cost" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Provision Status</label>
                    <input type="text" class=" form-control" disabled placeholder="Provision Status"
                      v-model="objData.provision_status" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Delivery Info</label>
                    <textarea name="" class="form-control" id="" cols="30" rows="3" v-model="objData.delivery_info"
                      style="resize: none" disabled placeholder="Delivery Infomation"></textarea>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Address</label>
                    <textarea name="" class="form-control" id="" cols="30" rows="3" v-model="objData.address"
                      style="resize: none" disabled placeholder="Address"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">City</label>
                    <input type="text" class=" form-control" disabled placeholder="City" v-model="objData.city" />
                  </div>
                </div>
                <div class="col-md-6" v-if="objData.state">
                  <div class="form-group">
                    <label for="">State</label>
                    <input type="text" class=" form-control" disabled placeholder="State"
                      v-model="objData.state.name" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Date Created</label>
                    <div class=" fw-bold text-success">
                      {{ objData.created_at | date }}
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card mt-2">
            <div class="card-body">
              <div class="shadow-sm rounded-2 max-width my-2"
                v-for="trail in objData.trail" :key="trail.date">
                <p class="m-0 fw-bold text-dark">
                  {{ trail.message }} 
                </p>
                <p class="m-0">
                  {{ trail.type }}
                </p>
                <br>
                <p class="m-0 text-info text-italic">                 
                  {{ trail.date }}
                </p>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="">Status</label>
                    <select class="form-control" v-model="thread_info.status">
                      <option value="" disabled selected>Please Select Status</option>
                      <option value="Your card request is processed">Your card request is processed</option>
                      <option value="Your card is ready for delivery">Your card is ready for delivery</option>
                      <option value="Your rider is on the way">Your rider is on the way</option>
                      <option value="Your card has been delivered">Your card has been delivered</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="">Type</label>
                    <select class="form-control" v-model="thread_info.type">
                      <option value="" disabled selected>Please Select Type</option>
                      <option value="delivery">Delivery</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group" v-if="thread_info.status == 'other'">
                    <label for="">Message</label>
                    <textarea name="" id="" cols="30" rows="4" class="form-control" style="resize: none"
                      v-model="thread_info.message"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <button class="btn btn-primary" @click="updateTrail">
                    <span v-if="trailloading" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Create Thread</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="objData.kiddiesAccount">
          <div class="card mt-2">
            <div class="card-body">
              <img
                :src="objData.kiddiesAccount.card_image"
                alt="Profile"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
    <CModal v-show="isProvisionVisible" @close="closeProModal" modalIsLarge footer>
      <template v-slot:title>
        <h4>Provision Card</h4>
      </template>
      <template v-slot:body>
        <div class="form-group">
          <label for=""> Card Name<span class=" text-danger">*</span> </label>
          <input type="text" class=" form-control" v-model="card_name" placeholder="John DOe" />
        </div>
        <div class="form-group">
          <label for="">
            Card Number <span class=" text-danger">*</span>
          </label>
          <input type="text" class=" form-control" v-model="card_number" @keypress="isNumber($event)" maxlength="25"
            placeholder="758948498484984 " />
        </div>
        <div class="form-group">
          <label for=""> Card CVV <span class=" text-danger">*</span> </label>
          <input type="text" class=" form-control" v-model="card_cvv" maxlength="3" placeholder="758 " />
        </div>
        <div class="form-group">
          <label for="">
            Card Expiry <span class=" text-danger">*</span>
          </label>
          <input @input="checkExpression" type="text" class=" form-control" v-model="card_expiry" maxlength="5"
            placeholder="Enter expression (MM/YY) E.g 01/00  " />
          <p v-if="isValid" class="text-success">Card Expiry Is Valid</p>
          <p v-else class="text-danger">Card Expiry is invalid.</p>
        </div>
      </template>
      <template v-slot:footer>
        <button @click="provisionCard" class="btn btn-primary" :disabled="!formIsValid || formLoading">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span>Please wait...</span>
          </span>
          <span v-else>Proceed</span>
        </button>
        <button @click="closeProModal" class="btn btn-danger">Close</button>
      </template>
    </CModal>
    <CModal v-show="isProvisionPINVisible" @close="closeProPINModal" modalIsLarge footer>
      <template v-slot:title>
        <h4>Provision Card PIN</h4>
      </template>
      <template v-slot:body>        
        <div class="form-group">
          <label for=""> Card PIN <span class=" text-danger">*</span> </label>
          <input type="text" class=" form-control" v-model="card_pin" maxlength="4" placeholder="758 " />
        </div>        
      </template>
      <template v-slot:footer>
        <button @click="provisionCardPIN" class="btn btn-primary">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span>Please wait...</span>
          </span>
          <span v-else>Proceed</span>
        </button>
        <button @click="closeProPINModal" class="btn btn-danger">Close</button>
      </template>
    </CModal>
    <CModal v-show="isModalVisible" @close="closeTreatModal" modalIsLarge footer>
      <template v-slot:title>
        <h4>Treat Card</h4>
      </template>
      <template v-slot:body>
        <div class="form-group">
          <label for="">Request Status</label>
          <select name="" id="" v-model="request_status" class=" form-control">
            <option value="" selected disabled>Please Status</option>
            <option value="approved">Approved</option>
            <option value="declined">Declined</option>
            <option value="decline-and-refund">Decline And Refund</option>
          </select>
        </div>
        <div class="form-group">
          <label for="">Request Status Message</label>
          <textarea name="" id="" cols="30" rows="4" v-model="request_status_message" class="form-control"
            placeholder="Request Status Message" style="resize: none"></textarea>
        </div>
      </template>
      <template v-slot:footer>
        <button class=" btn btn-primary" @click="treatCard" :disabled="formLoading ||
          request_status_message === '' ||
          request_status === ''
          ">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span>Please wait...</span>
          </span>
          <span v-else>Proceed</span>
        </button>
        <button class="btn btn-danger" @click="closeTreatModal">Close</button>
      </template>
    </CModal>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import Swal from "sweetalert2";
import CModal from "../../components/CModal.vue";
import ErrorService from "../../services/error.service";
export default {
  name: "SingleCard",
  props: {
    slug: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    formIsValid() {
      return (
        this.card_name !== "" &&
        this.card_number !== "" &&
        this.card_expiry !== "" &&
        this.card_cvv !== ""
      );
    }
  },
  components: {
    CModal
  },
  data() {
    return {
      isValid: false,
      formLoading: false,
      trailloading: false,
      request_status_message: "",
      request_status: "",
      objData: null,
      loading: true,
      isModalVisible: false,
      isProvisionVisible: false,
      isProvisionPINVisible: false,
      card_name: "",
      card_number: "",
      card_expiry: "",
      card_cvv: "",
      other_status: "",
      status: "",
      card_pin: "",
      thread_info: {
        status: "",
        type: "",
        message: ""
      }
    };
  },
  methods: {
    isNumber: function (evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkExpression() {
      const currentYear = new Date()
        .getFullYear()
        .toString()
        .substr(-2); // Get the current year and convert it to a two-digit string
      console.log(currentYear);

      // const regex = /^(0[1-9]|1[0-2])\/(0[0-9]|1[0-9]|2[0-9]|3[0-9])$/;
      const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
      // this.isValid = regex.test(this.card_expiry);
      // const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-9][0-9])$/;

      const [, yy] = this.card_expiry.split("/");
      console.log(yy);
      console.log(
        regex.test(this.card_expiry) && parseInt(yy) >= parseInt(currentYear)
      );
      this.isValid =
        regex.test(this.card_expiry) && parseInt(yy) >= parseInt(currentYear);
    },

    openProModal() {
      this.isProvisionVisible = true;
    },
    
    openProPINModal() {
      this.isProvisionPINVisible = true;
    },
    closeProPINModal() {
      this.isProvisionPINVisible = false;
      this.formLoading = false;
      this.card_pin = "";
    },
    closeProModal() {
      this.isProvisionVisible = false;
      this.formLoading = false;

      this.card_cvv = "";
      this.card_expiry = "";
      this.card_name = "";
      this.card_number = "";
    },
    openTreatModal() {
      this.isModalVisible = true;
    },
    closeTreatModal() {
      this.isModalVisible = false;
      this.request_status = "";
      this.request_status_message = "";
    },
    async getData() {
      try {
        const res = await ApiService.get(`card/view-card-request/${this.slug}`);
        console.log(res);
        this.objData = res.data.data;
        this.loading = false;
      } catch (error) {
        console.log(error.response);
        this.loading = false;
      }
    },
    async treatCard() {
      try {
        this.formLoading = true;
        const res = await ApiService.post("card/treat-card-request", {
          request_reference: this.slug,
          request_status: this.request_status,
          request_status_message: this.request_status_message
        });

        this.isModalVisible = false;
        this.formLoading = false;
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.getData();
      } catch (error) {
        this.closeTreatModal();
        this.formLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async provisionCardPIN() {
      if (this.card_pin.length < 4) {
        this.isProvisionPINVisible = false;
        Swal.fire({
          title: "Error!",
          text: "You've an invalid PIN for the card",
          icon: "error",
          timer: 3000
        });
        setTimeout(() => {
          this.isProvisionPINVisible = true;
        }, 4000);
      }else{
        this.isProvisionPINVisible = false;
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger me-2",
            title: "text-center h6 fw-bold text-black d-block"
          },
          buttonsStyling: false
        });
        swalWithBootstrapButtons
          .fire({
            title: `<div>
           <p >Are you sure you want provision this card PIN</p>
           <p class='m-0'>Card PIN: <span>${this.card_pin}</span></p>
           </div>`,
            text: "You won't be able to revert",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, continue!",
            cancelButtonText: "No Cancel",
            reverseButtons: true
          })
          .then(result => {
            if (result.isConfirmed) {
              swalWithBootstrapButtons
                .fire({
                  title:  `<div>
                    <p >Are you really sure you want provision this card PIN</p>
                    <p class='m-0'>Card PIN: <span>${this.card_pin}</span></p>
                    </div>`,
                  text: "You won't be able to revert",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, continue!",
                  cancelButtonText: "No Cancel",
                  reverseButtons: true
                })
                .then(result => {
                  if (result.isConfirmed) {
                    this.proPINAction();
                  } else if (result.dismiss == Swal.DismissReason.cancel) {
                    this.isProvisionVisible = true;
                  }
                });
            } else if (result.dismiss == Swal.DismissReason.cancel) {
              this.isProvisionVisible = true;
            }
          });
      }
    },
    async provisionCard() {
      if (!this.isValid) {
        this.isProvisionVisible = false;
        Swal.fire({
          title: "Error!",
          text: "You've an invalid expiration date for the card",
          icon: "error",
          timer: 3000
        });
        setTimeout(() => {
          this.isProvisionVisible = true;
        }, 4000);
      } else {
        this.isProvisionVisible = false;

        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger me-2",
            title: "text-center h6 fw-bold text-black d-block"
          },
          buttonsStyling: false
        });

        swalWithBootstrapButtons
          .fire({
            title: `<div>
           <p >Are you sure you want provision this card</p>
           <p class='m-0'>Card Name: <span>${this.card_name}</span></p>
           <p class='m-0'>Card Number: <span>${this.card_number}</span></p>
           <p class='m-0'>Card CVV: <span>${this.card_cvv}</span></p>
           <p class='m-0'>Card Expiry Date: <span>${this.card_expiry}</span></p>
           </div>`,
            text: "You won't be able to revert",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, continue!",
            cancelButtonText: "No Cancel",
            reverseButtons: true
          })
          .then(result => {
            if (result.isConfirmed) {
              swalWithBootstrapButtons
                .fire({
                  title: `Are you sure you want to perform this operation.`,
                  text: "You won't be able to revert",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, continue!",
                  cancelButtonText: "No Cancel",
                  reverseButtons: true
                })
                .then(result => {
                  if (result.isConfirmed) {
                    this.proAction();
                  } else if (result.dismiss == Swal.DismissReason.cancel) {
                    this.isProvisionVisible = true;
                  }
                });
            } else if (result.dismiss == Swal.DismissReason.cancel) {
              this.isProvisionVisible = true;
            }
          });
      }
    },
    async proAction() {
      try {
        this.formLoading = true;
        this.isProvisionVisible = true;
        const res = await ApiService.post("card/provision-card", {
          request_reference: this.slug,
          card_name: this.card_name,
          card_number: this.card_number,
          card_cvv: this.card_cvv,
          card_expiry: this.card_expiry,
          pin : this.card_pin
        });

        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getData();
        this.closeProModal();
      } catch (error) {
        this.isProvisionVisible = false;
        this.formLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async proPINAction() {
      try {
        this.formLoading = true;
        this.isProvisionPINVisible = false;
        const res = await ApiService.post("card/provision-card-pin", {
          request_reference: this.slug,
          pin : this.card_pin
        });

        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getData();
        this.closeProModal();
      } catch (error) {
        this.isProvisionPINVisible = false;
        this.formLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateTrail() {      
      this.thread_info['request_reference'] = this.slug;
      if (this.thread_info.status == "" || this.thread_info.type == "") {
        Swal.fire({
          title: "Error!",
          text: "Please select status and type",
          icon: "error",
          timer: 3000
        });
        return;
      }
      if (this.thread_info.status != 'other'){
        this.thread_info.message = this.thread_info.status;
      }
      Swal.fire({
        title: `Are you sure you want to create Trail?`,
        showCancelButton: true,
        confirmButtonText: `Yes,Create it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.trailloading = true;
          try {
            const response = await ApiService.post(
              `card/update-trail`,
              this.thread_info
            );     
            this.trailloading = false;     
            Swal.fire({
              title: "Success",
              text: response.data.message,
              icon: "success",
              timer: 3000,
              confirmButtonText: "Close",
              showConfirmButton: false
            });
            this.getData();
          } catch (error) {
            console.log(error.response);
            let _error = error.response.data;
            this.trailloading = false;   
            ErrorService.displayErrorAlert(_error);
          }
        }
      });
    }
  },
  mounted() {
    console.log(this.slug);
    this.getData();
  }
};
</script>

<style scoped></style>
